
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Mumbaitolonavalacab() {



    const cardData =
    {
        keyword: 'Mumbai to Lonavala Cab',
        heading: 'Meghana Cab : Mumbai to Lonavala Cab',
        headingDescription: 'Meghana Cab offers Mumbai to Lonavala Cab services, providing a smooth and scenic ride to the popular hill station nestled in the Sahyadri range. Whether you are heading for a quick weekend getaway, a romantic trip, or a family picnic, our well-maintained cabs with courteous drivers ensure a safe and relaxing journey. Choose from a wide range of vehicles—hatchbacks, sedans, SUVs, and tempo travellers—to suit your group size and comfort level. Enjoy transparent pricing, on-time pickup, and 24/7 customer assistance. Book your Mumbai to Lonavala Cab with Meghana Cab and enjoy the lush greenery, misty hills, and tranquil escape with utmost ease and convenience.',


        top: 'Top Places to Visit in Lonavala with Meghana Cab',

"topPlaces": [
  {
    "title": "Tiger’s Leap",
    "description": "A dramatic cliff‑side viewpoint featuring a sheer 650 m drop that resembles a leaping tiger, especially striking in monsoon mist. Offers panoramic vistas of the Western Ghats, an echo point, and a seasonal waterfall that forms right at the edge—ideal for breathtaking sunrise and sunset moments." 
  },
  {
    "title": "Bhushi Dam",
    "description": "A bustling masonry dam on the Indrayani River, hugely popular during the rains. Visitors flock to enjoy trekking across its slick steps and feel the cascading water. Though swimming is prohibited, the lively atmosphere, lush surroundings, and photo ops amid flowing water make it a monsoon favorite." 
  },
  {
    "title": "Rajmachi Fort",
    "description": "A twin‑fort hilltop complex (Shrivardhan & Manaranjan) perched amidst verdant Sahyadri ranges. A moderate trek rewards visitors with expansive valley views, fireflies by night, and ancient ramparts echoing Maratha-era strategic elegance and trekking charm." 
  },
  {
    "title": "Pawna Lake",
    "description": "A serene artificial reservoir with crystalline waters encircled by ghats. It's renowned for lakeside camping under starry skies, tranquil sunset reflections, and boating. Especially magical during summer and monsoon when the lake is fullest and the landscape bursts into emerald hues." 
  },
  {
    "title": "Lohagad Fort",
    "description": "Known as the 'Iron Fort', this 1033 m-high hill fortress dates to the 10th century and was later seized by Shivaji in 1648. The climb, particularly scenic in monsoon, passes by Bhaja Caves and features iconic structures like Ganesh Darwaja, step‑wells, and sweeping plateau views." 
  },
  {
    "title": "Karla Caves",
    "description": "An ancient Buddhist cave complex circa 2nd century BCE–5th century CE, located 11 km from Lonavala. Highlights include the Great Chaitya—the largest preserved rock‑cut prayer hall in India—and the Ekvira Devi temple, standing as archaeological marvels along an ancient trade route." 
  },
  {
    "title": "Bhaja Caves",
    "description": "A cluster of 2nd-century BCE Buddhist rock‑cut caves near Lohagad. Featuring stupas, vihara halls, and intricate rock carvings, they are among the oldest cave shrines in Maharashtra and are often visited together with Lohagad during monsoon‑season treks." 
  },
  {
    "title": "Lion’s Point",
    "description": "A quiet overlook near Bhushi Dam offering sweeping views of the valley below—particularly stunning at sunrise. Named after the Lions Club, the viewpoint includes snack stalls selling roasted corn and street food, popular for a peaceful stroll with mist‑laden panoramas." 
  },
  {
    "title": "Della Adventure Park",
    "description": "Spread across 36 acres, this is India’s largest recreation park, offering over 50 adventure activities (from zip‑lining to glamping) alongside luxury villas and onsite dining. It’s a go‑to destination for thrill‑seekers and families seeking adrenaline‑filled fun." 
  },
  {
    "title": "Tungarli Dam & Lake",
    "description": "A tranquil, lesser‑crowded reservoir set in lush hill terrain. Built during the British era, it’s surrounded by forested slopes and ideal for quiet picnics, birdwatching, and reflective walks—offering a peaceful alternative to the more frequented Bhushi or Pawna areas." 
  }
],

"services": [
  {
    "name": "Book Cab Mumbai to Lonavala",
    "description": "Easily book your cab from Mumbai to Lonavala with our hassle-free service. Enjoy prompt pickups, clean vehicles, and experienced drivers to make your journey relaxing and enjoyable."
  },
  {
    "name": "One Way Taxi Mumbai to Lonavala",
    "description": "Travel one-way from Mumbai to Lonavala with our reliable taxi service. Perfect for quick trips, our cabs offer punctual pickups, comfortable seating, and safe rides ensuring a smooth journey."
  },
  {
    "name": "Round Trip Cab Mumbai to Lonavala",
    "description": "Plan your round trip from Mumbai to Lonavala with ease. Whether a day trip or an extended stay, our well-maintained cars, courteous drivers, and flexible packages provide a stress-free travel experience."
  },
  {
    "name": "AC Sedan Mumbai to Lonavala Hire",
    "description": "Travel in comfort and style with our air-conditioned sedan hire from Mumbai to Lonavala. Ideal for solo travelers and couples looking for a smooth, cool, and pleasant journey."
  },
  {
    "name": "SUV Travel Cab Mumbai to Lonavala",
    "description": "Choose our spacious SUVs for your trip from Mumbai to Lonavala. Perfect for families or groups, these vehicles offer ample space for luggage and passengers without compromising comfort."
  },
  {
    "name": "Affordable Cab Fare Mumbai to Lonavala",
    "description": "Experience budget-friendly cab fares from Mumbai to Lonavala without compromising on safety or comfort. Our affordable pricing ensures value-packed travel for all budgets."
  },
  {
    "name": "Weekend Trip Taxi Mumbai to Lonavala",
    "description": "Make your weekend getaway to Lonavala memorable with our dedicated weekend trip taxi service from Mumbai. Enjoy flexible timings, comfortable rides, and scenic routes."
  },
  {
    "name": "Lonavala Tour from Mumbai by Car",
    "description": "Explore Lonavala’s beautiful spots with our guided tour service. Travel from Mumbai in comfortable cars driven by knowledgeable drivers who ensure you don’t miss any must-see locations."
  },
  {
    "name": "Online Booking Mumbai to Lonavala Cab",
    "description": "Book your Mumbai to Lonavala cab conveniently online. Choose your vehicle, schedule your pickup, and receive instant confirmation for a seamless travel experience."
  },
  {
    "name": "Family Cabs Mumbai to Lonavala",
    "description": "Make your family trip special with our family-friendly cabs from Mumbai to Lonavala. Spacious vehicles, safety-first driving, and flexible itineraries ensure a fun and comfortable journey for all ages."
  },
  {
    "name": "Mumbai to Lonavala Chauffeur Cab",
    "description": "Travel with elegance and convenience in our chauffeur-driven cabs from Mumbai to Lonavala. Perfect for business or leisure, our professional drivers ensure a smooth and stress-free ride."
  },
  {
    "name": "Private Car Mumbai to Lonavala",
    "description": "Hire a private car from Mumbai to Lonavala for personalized travel tailored to your schedule. Enjoy privacy, flexibility, and comfort throughout your journey."
  },
  {
    "name": "Fast Cab Booking Mumbai to Lonavala",
    "description": "Need a quick ride? Our fast cab booking service from Mumbai to Lonavala guarantees rapid confirmations and timely pickups, making last-minute travel plans hassle-free."
  },
  {
    "name": "24/7 Cab Hire Mumbai to Lonavala",
    "description": "Our 24/7 cab hire service from Mumbai to Lonavala is available whenever you need it. Day or night, count on prompt service, professional drivers, and reliable rides at any hour."
  },
  {
    "name": "Corporate Cabs Mumbai to Lonavala",
    "description": "Tailored corporate cab services from Mumbai to Lonavala, offering executive cars, professional chauffeurs, and timely rides designed to suit business travel requirements."
  }
],
"tableData": [
  ["Book Cab Mumbai to Lonavala", "One Way Taxi Mumbai to Lonavala"],
  ["Round Trip Cab Mumbai to Lonavala", "AC Sedan Mumbai to Lonavala Hire"],
  ["SUV Travel Cab Mumbai to Lonavala", "Affordable Cab Fare Mumbai to Lonavala"],
  ["Weekend Trip Taxi Mumbai to Lonavala", "Lonavala Tour from Mumbai by Car"],
  ["Online Booking Mumbai to Lonavala Cab", "Family Cabs Mumbai to Lonavala"],
  ["Mumbai to Lonavala Chauffeur Cab", "Private Car Mumbai to Lonavala"],
  ["Fast Cab Booking Mumbai to Lonavala", "24/7 Cab Hire Mumbai to Lonavala"],
  ["Corporate Cabs Mumbai to Lonavala", ""]
],








"whychoose": [
    {
        "WhyChooseheading": "Trusted Mumbai to Lonavala Cab Service",
        "WhyChoosedescription": "Meghana Cab provides a reliable and comfortable cab service from Mumbai to Lonavala, perfect for weekend getaways, family trips, or solo travelers. Our fleet consists of well-maintained, air-conditioned vehicles to ensure a smooth and enjoyable journey through scenic routes, making your travel stress-free and pleasant."
    },
    {
        "WhyChooseheading": "Flexible and Comprehensive Travel Packages",
        "WhyChoosedescription": "We offer a variety of travel packages tailored to your needs, including one-way trips, round trips, and multi-day tours to explore the best of Lonavala and nearby hill stations. Our team plans your itinerary efficiently, covering popular attractions like Bushi Dam, Karla Caves, and Lion’s Point, so you get the most out of your visit without worrying about logistics."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our Mumbai to Lonavala cab fares are competitively priced and inclusive of all necessary costs such as fuel, tolls, driver allowances, and taxes. We provide upfront pricing to ensure complete transparency, enabling you to select a vehicle and package that best fits your budget without any surprises during or after your trip."
    },
    {
        "WhyChooseheading": "Comfortable, Clean, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in style and comfort with our range of vehicles, including sedans, SUVs, and tempo travellers. All our vehicles are regularly sanitized and maintained to ensure a hygienic and safe environment, especially important for long drives. Enjoy air-conditioning, ample luggage space, and plush seating for a relaxing journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Expertise",
        "WhyChoosedescription": "Our professional drivers are not only skilled but also deeply familiar with the Mumbai-Lonavala route and surrounding areas. They know the best routes to avoid traffic and can suggest scenic detours or local spots to enhance your travel experience. Safety and punctuality are their top priorities throughout your trip."
    },
    {
        "WhyChooseheading": "Customizable Trip Plans to Suit Your Schedule",
        "WhyChoosedescription": "Whether you prefer a quick day trip or a leisurely multi-day stay in Lonavala, we offer flexible scheduling options. You can customize your itinerary with stops at sightseeing locations, meal breaks, or overnight stays, giving you complete control over your travel pace and preferences."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Dedicated Customer Care",
        "WhyChoosedescription": "Book your Mumbai to Lonavala cab anytime with our round-the-clock booking support. Our customer care team is always ready to assist you with any queries, last-minute changes, or special requests, ensuring a seamless and hassle-free travel experience from start to finish."
    },
    {
        "WhyChooseheading": "Ideal for Families, Groups, and Corporate Travelers",
        "WhyChoosedescription": "Our cab service is perfect for a variety of travelers including families looking for a comfortable trip, groups of friends on vacation, and corporate clients needing reliable transport. We prioritize safety, comfort, and timely service to make your Mumbai to Lonavala journey enjoyable and memorable."
    }
]
























    }

const faqData = [
    {
        question: "How can I book a cab from Mumbai to Lonavala with Meghana Cab?",
        answer: "You can book your Mumbai to Lonavala cab by calling Meghana Cab at +91 9075462128 or via our website for a smooth booking process."
    },
    {
        question: "What vehicle options are available for the Mumbai to Lonavala route?",
        answer: "We offer sedans, SUVs, and tempo travellers suitable for solo travelers, families, and groups."
    },
    {
        question: "Are Meghana Cab drivers familiar with the Mumbai to Lonavala route?",
        answer: "Yes, our drivers are experienced with the Mumbai to Lonavala route ensuring a safe and comfortable journey."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Lonavala?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip cab services."
    },
    {
        question: "Is the fare inclusive of tolls, fuel, and driver charges?",
        answer: "Our fare includes fuel, tolls, and driver charges. Additional charges may apply for parking or waiting time."
    },
    {
        question: "Are the vehicles sanitized before the trip?",
        answer: "Yes, all vehicles are thoroughly sanitized before each journey for your safety and comfort."
    },
    {
        question: "Is the Mumbai to Lonavala cab service available 24/7?",
        answer: "Yes, we provide round-the-clock cab services from Mumbai to Lonavala."
    },
    {
        question: "Can I request stops for meals or sightseeing during the trip?",
        answer: "Yes, halts can be arranged on request. Please inform us while booking."
    },
    {
        question: "What payment methods do you accept?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How do I contact Meghana Cab to book a Mumbai to Lonavala cab?",
        answer: "Call us anytime at +91 9075462128 to book your cab or for travel assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rohan Mehta',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth and comfortable ride from Mumbai to Lonavala with Meghana Cab. The driver was very professional.”',
    },
    {
        name: 'Ms. Kavita Singh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great service by Meghana Cab for our trip to Lonavala. Timely pick-up and clean vehicle.”',
    },
];









































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const mumbaiToLonavalaCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Mumbai to Lonavala Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/mumbai-to-lonavala-cab.jpg",
  "description": "Book affordable and reliable taxi service from Mumbai to Lonavala with Meghana Cabs. One way and round trip options with AC sedans and SUVs available.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "Book Cab Mumbai to Lonavala",
    "One Way Taxi Mumbai to Lonavala",
    "Round Trip Cab Mumbai to Lonavala",
    "AC Sedan Mumbai to Lonavala Hire",
    "SUV Travel Cab Mumbai to Lonavala",
    "Affordable Cab Fare Mumbai to Lonavala",
    "Weekend Trip Taxi Mumbai to Lonavala",
    "Lonavala Tour from Mumbai by Car",
    "Online Booking Mumbai to Lonavala Cab",
    "Family Cabs Mumbai to Lonavala",
    "Mumbai to Lonavala Chauffeur Cab",
    "Private Car Mumbai to Lonavala",
    "Fast Cab Booking Mumbai to Lonavala",
    "24/7 Cab Hire Mumbai to Lonavala",
    "Corporate Cabs Mumbai to Lonavala"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Lonavala Taxi Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Taxi Mumbai to Lonavala"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Cab Mumbai to Lonavala"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "AC Sedan Mumbai to Lonavala Hire"
        }
      }
    ]
  }
};






    return (
        <div>


<Helmet>
  <title>Mumbai to Lonavala Cab | Meghana Cabs</title>
  <meta
    name="description"
    content="Book affordable and reliable taxi service from Mumbai to Lonavala with Meghana Cabs. One way and round trip options with AC sedans and SUVs available."
  />
  <meta
    name="keywords"
    content="Book Cab Mumbai to Lonavala, One Way Taxi Mumbai to Lonavala, Round Trip Cab Mumbai to Lonavala, AC Sedan Mumbai to Lonavala Hire, SUV Travel Cab Mumbai to Lonavala, Affordable Cab Fare Mumbai to Lonavala, Weekend Trip Taxi Mumbai to Lonavala, Lonavala Tour from Mumbai by Car, Online Booking Mumbai to Lonavala Cab, Family Cabs Mumbai to Lonavala, Mumbai to Lonavala Chauffeur Cab, Private Car Mumbai to Lonavala, Fast Cab Booking Mumbai to Lonavala, 24/7 Cab Hire Mumbai to Lonavala, Corporate Cabs Mumbai to Lonavala"
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiToLonavalaCabSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitolonavalacab;